import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BasicButton from "./BasicButton.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonContactAdmin',
  setup(__props) {

const contactAdmin = () => {
  window.location.href = "mailto:alicia@26lights.com";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasicButton, {
    "icon-name": "mdi:email",
    variant: "outline",
    onClick: contactAdmin
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t("buttons.contactAdmin")), 1)
    ]),
    _: 1
  }))
}
}

})